<template>
  <transition name="modal">
    <div class="modal-wrapper">
      <b-card class="modal-container-tester">
        <div>
          <div class="mt-2" v-if="parametres.length!==0">
          <span v-for="param in parametres"
                v-bind:key="param.idParametre">Parametre: {{param.valeur}}
            <b-form-input  placeholder="Entrez une valeur pour le paramètre"
                           v-model="saisieMap[param.idParametre]"
            ></b-form-input>
          </span>
          </div>
          <b-button pill @click ="TesterRequete" class="nav-link1 m-2">Tester</b-button>

        </div>
      </b-card>
    </div>
  </transition>

</template>

<script>
import {useTesterRequete} from "@/composition/Requetes/testerRequete";

export default {
  name:'TesterRequete',

  props: {
    idRequete:{
      required:true,
      type:Number
    },
    parametres:{
      type:Array
    },
    sql:{
      required:true,
      type:String
    }
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
   return useTesterRequete(props,{emit})
  }
}

</script>

<style>

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-container-tester {
  background-color: #c0c0c0;
  width: 80%;
  margin: 0px auto;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>